import React, { useEffect, useState } from "react";
import "./Messages.css";

function Messages() {
  const [messages, setMessages] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedMessage, setSelectedMessage] = useState(null);

  // Fetch messages from backend
  const fetchMessages = () => {
    fetch("https://api.kemari-corp.com/getMessages.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setMessages(data.data);
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  // Update status (optimistic UI)
  const updateStatus = (id, status) => {
    setMessages(messages.map((m) => (m.id === id ? { ...m, status } : m)));

    if (selectedMessage && selectedMessage.id === id) {
      setSelectedMessage((prev) => ({ ...prev, status }));
    }

    fetch("https://api.kemari-corp.com/updateMessageStatus.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, status }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status !== "success") fetchMessages();
      })
      .catch(() => fetchMessages());
  };

  // Filtered & searched messages
  const displayedMessages = messages.filter((m) => {
    return (
      (statusFilter === "" || m.status === statusFilter) &&
      (m.name.toLowerCase().includes(search.toLowerCase()) ||
        m.email.toLowerCase().includes(search.toLowerCase()) ||
        m.message.toLowerCase().includes(search.toLowerCase()))
    );
  });

  return (
    <div className="msg-root">
      {/* Page Header */}
      <div className="msg-page-header">
        <h2 className="msg-headline">Contact Messages</h2>
      </div>

      {/* Filter / Search */}
      <div className="msg-filter-bar">
        <div className="msg-search-wrap">
          <svg className="msg-search-icon" viewBox="0 0 20 20" fill="none">
            <circle cx="9" cy="9" r="6" stroke="currentColor" strokeWidth="1.5" />
            <path d="M13.5 13.5L17 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            className="msg-search"
            placeholder="Search messages…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="msg-pill-group">
          {["", "New", "Replied"].map((val) => (
            <button
              key={val}
              className={`msg-pill ${statusFilter === val ? "active" : ""}`}
              onClick={() => setStatusFilter(val)}
            >
              {val === "" ? "All" : val}
            </button>
          ))}
        </div>
      </div>

      {/* Message List */}
      <div className="msg-list">
        {displayedMessages.length === 0 ? (
          <p className="msg-empty">No messages found</p>
        ) : (
          displayedMessages.map((m, i) => (
            <div
              key={m.id}
              className="msg-row"
              style={{ animationDelay: `${i * 40}ms` }}
              onClick={() => setSelectedMessage(m)}
            >
              <div className="msg-avatar">
                {m.name.charAt(0).toUpperCase()}
              </div>

              <div className="msg-row-info">
                <span className="msg-row-name">{m.name}</span>
                <span className="msg-row-email">{m.email}</span>
              </div>

              <div className="msg-row-right">
                <span className={`msg-badge ${m.status === "Replied" ? "replied" : "new"}`}>
                  {m.status || "New"}
                </span>
                <svg className="msg-chevron" viewBox="0 0 8 14" fill="none">
                  <path d="M1 1l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Modal */}
      {selectedMessage && (
        <div className="msg-overlay" onClick={() => setSelectedMessage(null)}>
          <div className="msg-modal" onClick={(e) => e.stopPropagation()}>

            {/* Fixed top: handle + sender details */}
            <div className="msg-modal-fixed-top">
              <div className="msg-handle" />
              <div className="msg-modal-top">
                <div className="msg-modal-avatar">
                  {selectedMessage.name.charAt(0).toUpperCase()}
                </div>
                <div className="msg-modal-meta">
                  <p className="msg-modal-name">{selectedMessage.name}</p>
                  <p className="msg-modal-email">{selectedMessage.email}</p>
                  {selectedMessage.phone && (
                    <p className="msg-modal-phone">{selectedMessage.phone}</p>
                  )}
                </div>
                <span className={`msg-badge ${selectedMessage.status === "Replied" ? "replied" : "new"}`}>
                  {selectedMessage.status || "New"}
                </span>
              </div>
              <div className="msg-modal-divider" />
            </div>

            {/* Scrollable middle: message body */}
            <div className="msg-modal-scroll">
              <p className="msg-modal-body">{selectedMessage.message}</p>
            </div>

            {/* Fixed bottom: actions + close */}
            <div className="msg-modal-fixed-bottom">
              <div className="msg-modal-actions">
                <div className="msg-status-wrap">
                  <span className="msg-status-label">Status</span>
                  <select
                    className="msg-status-select"
                    value={selectedMessage.status || "New"}
                    onChange={(e) => updateStatus(selectedMessage.id, e.target.value)}
                  >
                    <option value="New">New</option>
                    <option value="Replied">Replied</option>
                  </select>
                </div>

                <a
                  href={`https://mail.google.com/mail/?view=cm&to=${selectedMessage.email}&subject=Re: Your Inquiry&body=Hello ${selectedMessage.name},`}
                  target="_blank"
                  rel="noreferrer"
                  className="msg-reply-btn"
                >
                  ✉ Reply via Email
                </a>
              </div>

              <button className="msg-close-btn" onClick={() => setSelectedMessage(null)}>
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default Messages;